import { types as t } from 'mobx-state-tree';
import { AbstractQuestionWithMultipleOption } from '../abstract-question-multiple-option.store';
import { KeyValueModel } from '../../key-value.store';

// TODO: merge with matching ending
export const MatchingFeatureNameAnswerQuestion = AbstractQuestionWithMultipleOption.named(
  'MatchingFeatureNameAnswerQuestion'
).props({
  featureNames: t.optional(t.array(KeyValueModel), []),
});
